import NES from './NES.js';

import * as Devices from './Controllers/Devices/index.js';

export { NES, Devices };
export default { NES, Devices };
